export default "__VITE_ASSET__GmOebIoQ__"